import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { cn } from "@/lib/utils";
import { railFade } from './sidebar/railMotion';

interface LogoProps {
  className?: string;
  /**
   * Only the round signet: the wordmark fades out (above the collapsed icon
   * rail). The signet stays put, so the change reads as a crossfade.
   */
  compact?: boolean;
}

const Logo: React.FC<LogoProps> = ({ className, compact = false }) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleLogoClick = () => {
    if (isAuthenticated) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  };

  return (
    <div
      data-variant={compact ? 'signet' : 'wordmark'}
      className={cn(
        "flex shrink-0 items-center cursor-pointer transition-transform duration-200 hover:scale-[1.02] motion-reduce:transition-none",
        className
      )}
      onClick={handleLogoClick}
    >
      <img
        src="/images/timeglobe.svg"
        alt="TimeGlobe Logo"
        className="h-[45px] mr-2 shrink-0"
      />
      <span
        aria-hidden={compact || undefined}
        className={cn(
          "whitespace-nowrap font-semibold text-[#0052F4] text-2xl tracking-tighter leading-none font-sans antialiased",
          railFade(compact),
        )}
      >
        TimeGlobe
      </span>
    </div>
  );
};

export default Logo;
